import angular from 'angular';

import './checkout.scss';

import modalsModule from './modals';
import commonModule from '../common';

import accountSettingsComponentsModule from 'portal/myaccount/settings/components';
import creditCardListComponent from './creditCardList.component';
import promoCodeComponent from './promoCode.component';
import checkoutAddressListComponent from './checkoutAddressList.component';
import checkoutAddressComponent from './checkoutAddress.component';
import upgradeComponent from './upgrade.component';
import upgradeService from './upgrade.service';

export default angular
    .module('fp:customerportal:shop:checkout', [
        commonModule.name,
        modalsModule.name,
        accountSettingsComponentsModule.name
    ])
    .component('fpCreditCardList', creditCardListComponent)
    .component('fpPromoCode', promoCodeComponent)
    .component('fpCheckoutAddressList', checkoutAddressListComponent)
    .component('fpCheckoutAddress', checkoutAddressComponent)
    .component('fpUpgrade', upgradeComponent)
    .service('upgradeService', upgradeService);
